module.exports = __webpack_public_path__ + "media/site/images/technologies/rails-icon-5aa5c645c8e9abeab813ef5ed1c77893.svg";